import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-regular-tables',
  templateUrl: './regular-tables.component.html',
  styleUrls: ['./regular-tables.component.scss']
})
export class RegularTablesComponent {
  @Input('columns') columns;
  @Input('data') data;

  constructor() {
    this.columns = [];
    this.data = [];
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.columns && changes.columns.currentValue) {
      this.columns = changes.columns.currentValue;
    }
    if (changes.data && changes.data.currentValue) {
      this.data = changes.data.currentValue;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/tables/regular-tables/regular-tables.component.ts